import { render, staticRenderFns } from "./passwordSettings.vue?vue&type=template&id=61279c22&"
import script from "./passwordSettings.vue?vue&type=script&lang=js&"
export * from "./passwordSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports